import React from "react";

import logo1 from "../../../assets/EMP_Retails/EMP_RetailTrusted/bath-and-body-works-logo.webp";

import logo2 from "../../../assets/EMP_Retails/EMP_RetailTrusted/logo-vera.png.webp";

import logo3 from "../../../assets/EMP_Retails/EMP_RetailTrusted/mall-of-america-logo.webp";

import researchImg from "../../../assets/EMP_Retails/EMP_RetailTrusted/new-research-study-retail.webp";

import logo4 from "../../../assets/EMP_Retails/EMP_RetailTrusted/sprinkles-logo.png.webp";

import logo5 from "../../../assets/EMP_Retails/EMP_RetailTrusted/tractor-supply-logo.png.webp";

import logo6 from "../../../assets/EMP_Retails/EMP_RetailTrusted/vista-logo.png.webp";

import researchimg from "../../../assets/EMP_Retails/EMP_RetailTrusted/new-research-study-retail.webp";


export default function EMP_RetailTrusted() {
  return (
    <>
<section className="w-full bg-[white] overflow-hidden">      
  {/* TOP LOGO SECTION */}
      <div
  className="
    w-full
    px-0
    py-16
  "
>
        {/* TITLE */}
        <h3
          className="
          lg:mt-[80px]
            text-center
            text-[16px]
            lg:text-[20px]
            font-bold
            uppercase
            tracking-wide
            text-black
          "
        >
          TRUSTED BY LEADING COMPANIES
        </h3>

        {/* LOGOS */}
        <div
          className="
            mt-10
            flex
            flex-wrap
            items-center
            justify-center
            gap-10
            lg:gap-16
          "
        >
          <img
            src={logo1}
            alt="Bath Body Works"
            className="h-[45px] object-contain"
          />

          <img
            src={logo2}
            alt="Vera Bradley"
            className="h-[50px] lg:w-[120px] object-contain"
          />

          <img
            src={logo3}
            alt="Mall Of America"
            className="h-[45px] object-contain"
          />

          <img
            src={logo4}
            alt="Sprinkles"
            className="h-[50px] object-contain"
          />

          <img
            src={logo5}
            alt="Tractor Supply"
            className="h-[45px] object-contain"
          />

          <img
            src={logo6}
            alt="Vista Outdoor"
            className="h-[45px] object-contain"
          />
        </div>
      </div>

      {/* RESEARCH SECTION */}
    <div
  className="
    relative
    bg-[#dfe4f3]
    mt-8
    w-full
    min-h-[90px]
  "
>
  <div
    className="
      w-full
      px-4
      sm:px-10
      lg:px-8
      py-6
      flex
      flex-col
      lg:flex-row
      items-center
      justify-between
      gap-6
      relative
    "
  >
    {/* LEFT IMAGE */}
    <div
      className="
        relative
        lg:absolute
        lg:left-[300px]
        lg:-top-[35px]
      "
    >
      <img
        src={researchimg}
        alt="Research Report"
        className="
          w-[120px]
          sm:w-[160px]
          object-contain
          drop-shadow-lg
        "
      />
    </div>

    {/* TEXT */}
    <div
      className="
        lg:ml-[450px]
        flex-1
      "
    >
      <h2
        className="
          text-[#220000]
          text-[22px]
          lg:text-[24px]
          leading-[1.2]
          font-semibold
          max-w-[900px]
        "
      >
        New Research: The State of Retail Workers'
        Finances
      </h2>
    </div>

    {/* BUTTON */}
    <button
      className="
        border-2
        border-[#2b0000]
        text-[#2b0000]
        hover:bg-[#2b0000]
        hover:text-white
        px-5
        py-2
        text-[17px]
        font-medium
        transition-all
        duration-300
        whitespace-nowrap
        lg:mr-[270px]
      "
    >
      Learn More
    </button>
  </div>
      </div>
    </section>

    {/* BENEFITS FOR RETAILERS */}

    <section
      className="
        w-full
        bg-[white]
        px-6
        sm:px-10
        lg:px-20
        py-20
        lg:py-28
      "
    >
      <div
        className="
          max-w-5xl
          mx-auto
          text-center
        "
      >
        {/* TOP LABEL */}
        <p
          className="
            text-[#b34700]
            text-[14px]
            sm:text-[15px]
            font-bold
            tracking-[2px]
            uppercase
            mb-6
          "
        >
          BENEFITS FOR RETAILERS
        </p>

        {/* HEADING */}
        <h1
          className="
            text-[#240000]
            text-[48px]
            sm:text-[62px]
            lg:text-[42px]
            leading-[1]
            font-sans
            lg:-mt-[10px]
          "
          style={{
            // fontFamily: "'Cormorant Garamond', serif",
          }}
        >
          How Can On-Demand Pay <br />
          Help the Retail Industry?
        </h1>

        {/* DESCRIPTION */}
        <p
          className="
            mt-7
            text-[#1c0a0a]
            text-[22px]
            lg:text-[16px]
            leading-[1.5]
            max-w-3xl
            mx-auto
          "
          style={{
            fontFamily: "'Inter', sans-serif",
          }}
        >
          When employees aren’t stressed over their finances, <br />
          they bring their best selves to work.
        </p>

        {/* BUTTON */}
        <button
          className="
            mt-7
            bg-[#2b0000]
            hover:bg-[#4a0000]
            text-white
            text-[16px]
            font-semibold
            px-5
            py-2.5
            transition-all
            duration-300
          "
        >
          Book a Demo
        </button>
      </div>
    </section>
    </ >
  );
}